import React, { useRef, useState, useEffect, useCallback } from 'react';
import * as XLSX from 'xlsx';
import {
  KTSVG,
  SimpleAlert,
  toAbsoluteUrl,
} from '../../../../../_mexablock/helpers';
import { Modal } from 'react-bootstrap-v5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { StepperComponent } from '../../../../../_mexablock/assets/ts/components';
import Stepper from '../../../../../_mexablock/helpers/components/Stepper';
import AnimationSucces from '../../../../../_mexablock/helpers/components/SuccesResponse';
import {
  getSelectTypeProvider,
  getSelectTypeStock,
} from '../../../../service/inventario/productos';
import Select from 'react-select';
import { NumericFormat } from 'react-number-format';
import { addProduct } from '../../../../service/inventario/productos';
import { QRImageUploader } from '../components/LectorQR';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
};

const currentDate = new Date();
const fechaMaxima = new Date(currentDate);
fechaMaxima.setFullYear(currentDate.getFullYear() - 18);

const initValues = {
  id: 0,
  typeStock: null,
  typeSupplier: null,
  description: '',
  purchasePrice: 0,
  salePrice: 0,
  location: '',
  avatar: '',
};

const stepperHeaders = ['Alta de producto', 'Almacenaje', 'Completado'];

const ValidationSchema = [
  Yup.object().shape({
    typeStock: Yup.mixed().required('Selecciona tipo'),
    typeSupplier: Yup.mixed().required('Selecciona proveedor'),
    description: Yup.string()
      .required('La descripción es requerida')
      .max(150, 'Máximo 150 caracteres.'),
    purchasePrice: Yup.number()
      .required('El precio de compra es requerido')
      .min(1, 'El precio de compra debe ser al menos $1.00.')
      .max(1000, 'El precio de compra no puede exceder $1,000.00.'),
    salePrice: Yup.number()
      .required('El precio de venta es requerido')
      .min(1, 'El precio de venta debe ser al menos $1.00.')
      .max(1000, 'El precio de venta no puede exceder $1,000.00.'),
  }),
  Yup.object().shape({
    location: Yup.string()
      .matches(
        /^[a-zA-Z0-9\s\/\-]{1,30}$/,
        'Solo se permiten letras, números, espacios y guiones. Máximo 30 caracteres.'
      )
      .required('La ubicación es requerida'),
  }),
];

const CreateModal: React.FC<Props> = ({ show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const stepper = useRef<StepperComponent | null>(null);
  const [selectProvider, setSelectProvider] = useState();
  const [qrData, setQrData] = useState<{ iccid: string; qrContent: string }[]>(
    []
  );
  const [selectStock, setSelectStock] = useState();
  const [currentSchema, setCurrentSchema] = useState<any>(ValidationSchema[0]);
  const [selectedOptionSupplier, setSelectedOptionSupplier] = useState(null);
  const [selectedOptionStock, setSelectedOptionStock] = useState(null);
  const [textStepper, setTextStepper] = useState('Continuar');
  const [previewImage, setPreviewImage] = useState<string | null | undefined>();
  const [selectTypeStock, setSelectTypeStock] = useState<number>(0);

  const productForm = useFormik({
    initialValues: initValues,
    validationSchema: currentSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setLoading(true);
      const curIndex = stepper.current?.currentStepIndex;
      switch (curIndex) {
        case 1:
          stepper.current?.goNext();
          setCurrentSchema(ValidationSchema[1]);
          setLoading(false);
          break;

        case 2:
          if (!dataInventario.length) {
            SimpleAlert('No se ha cargado ningún archivo', 3000, 'error');
            setLoading(false);
            return;
          }
          const inconsistencias = dataInventario.some(
            (item) =>
              !item.imsi ||
              !item.iccid ||
              !item.puk ||
              !item.pin ||
              !item.msisdn ||
              String(item.iccid).length !== 19
          );

          if (inconsistencias) {
            SimpleAlert(
              'Se detectaron inconsistencias en uno o más registros. Algunos campos están vacíos o no cumplen con la longitud esperada. Por favor, revisa y corrige los datos antes de continuar',
              5000,
              'error'
            );
            setLoading(false);
            return;
          }
          if (values.typeStock === 2) {
            const allHaveQR = dataInventario.every(
              (item) => !!item.sim_virtual
            );
            if (!allHaveQR) {
              SimpleAlert('Debes agregar QR al inventario.', 3000, 'error');
              setLoading(false);
              return;
            }
          }

          addProduct(values, dataInventario)
            .then(() => {
              stepper.current?.goNext();
            })
            .catch((err) => {
              const serverData = err?.response?.data;
              const customMessage =
                serverData?.message ||
                err?.message ||
                'Ocurrió un error en la operación';

              SimpleAlert(customMessage, 3000, 'error');

              if (serverData?.code === 'EXISTING_ICCID') {
                const repeatedICCIDs =
                  serverData?.field?.find((f: any) => f.type === 'repeated')
                    ?.iccids || [];

                const invalidICCIDs =
                  serverData?.field?.find((f: any) => f.type === 'invalid')
                    ?.iccids || [];

                const repeatedCleaned = repeatedICCIDs.map((iccid: string) =>
                  iccid.replace(/F$/, '')
                );

                const invalidCleaned = invalidICCIDs.map((iccid: string) =>
                  iccid.replace(/F$/, '')
                );

                const newDataInventario = dataInventario.map((item: any) => {
                  const cleanedIccid = String(item.iccid ?? '').replace(
                    /F$/,
                    ''
                  );
                  if (repeatedCleaned.includes(cleanedIccid)) {
                    return {
                      ...item,
                      respuesta: 'ICCID duplicado',
                    };
                  }
                  if (invalidCleaned.includes(cleanedIccid)) {
                    return {
                      ...item,
                      respuesta: 'ICCID inválido',
                    };
                  }
                  return {
                    ...item,
                    respuesta: 'Válido',
                  };
                });

                setDataInventario(newDataInventario);
              }
            })
            .finally(() => {
              setLoading(false);
            });
          break;
        case 3:
          onClose();
          break;
      }
    },
  });
  // Tabla

  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [dataInventario, setDataInventario] = useState<any[]>([]);
  const toggleSelect = (index: number) => {
    setSelectedRows((prev) => {
      const newSet = new Set(prev);
      newSet.has(index) ? newSet.delete(index) : newSet.add(index);
      return newSet;
    });
  };

  const isAllSelected =
    !!dataInventario?.length && selectedRows.size === dataInventario.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(dataInventario.map((_, index) => index)));
    }
  };

  const handleDeleteSelected = () => {
    const filtered = dataInventario.filter(
      (_, index) => !selectedRows.has(index)
    );
    setDataInventario(filtered);
    setSelectedRows(new Set());
  };

  // Fin tabla
  {
    /* ------------------------------- subir excel ----------------------------------- */
  }

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState<string | null>(null);
  const [fileSize, setFileSize] = useState<number>(0);

  const MAX_FILE_SIZE_MB = 15;
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

  const readExcel = async (file: File) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[1];
    const worksheet = workbook.Sheets[sheetName];

    if (!worksheet) {
      SimpleAlert('No se encontró "Hoja1" en el archivo.', 3000, 'error');
      return;
    }

    const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

    if (jsonData.length > 100) {
      SimpleAlert(
        `El archivo contiene ${jsonData.length} registros. El máximo permitido es 100.`,
        4000,
        'error'
      );
      return;
    }

    const mappedData = jsonData.map((row: any) => ({
      imsi: row['IMSI'],
      iccid: row['ICCID']?.replace(/F$/, '') ?? '',
      puk: row['PUK'],
      pin: row['PIN'],
      msisdn: row['MSISDN'],
    }));

    setDataInventario(mappedData);
  };

  const handleFile = async (file: File) => {
    if (file.size > MAX_FILE_SIZE_BYTES) {
      SimpleAlert(
        `El archivo supera los ${MAX_FILE_SIZE_MB} MB permitidos.`,
        3000,
        'error'
      );
      return;
    }

    setFileName(file.name);
    setFileSize(file.size);
    await readExcel(file);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      validateAndHandleFile(file);
      e.target.value = '';
    }
  };

  const validateAndHandleFile = (file: File) => {
    const validExtensions = ['.xlsx', '.xls'];
    const fileName = file.name.toLowerCase();
    const isValidExtension = validExtensions.some((ext) =>
      fileName.endsWith(ext)
    );

    if (!isValidExtension) {
      SimpleAlert(
        'El archivo seleccionado no es un archivo Excel. Intenta nuevamente con un archivo en formato .xlsx o .xls.',
        3000,
        'error'
      );
      return;
    }

    const MAX_FILE_SIZE_MB = 15;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

    if (file.size > MAX_FILE_SIZE_BYTES) {
      SimpleAlert(
        'El archivo excede los 15 MB. No se puede procesar.',
        3000,
        'error'
      );
      return;
    }

    handleFile(file);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();

    const file = e.dataTransfer.files?.[0];
    if (file) {
      validateAndHandleFile(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  {
    /* ------------------------------- fin subir excel ----------------------------------- */
  }
  // ------------------------------------- Inicio subir QR ---------------------------------------

  const handleDataChange = useCallback(
    (data: { iccid: string; qrContent: string }[]) => {
      const updatedDataInventario = dataInventario.map((item) => {
        const match = data.find((qrItem) => qrItem.iccid === item.iccid);
        const qrContent = match ? match.qrContent : null;

        return {
          ...item,
          sim_virtual: qrContent,
          resQR: qrContent ? 'Asignado' : 'No asignada',
        };
      });

      setQrData(data);
      setDataInventario(updatedDataInventario);
    },
    [dataInventario]
  );

  // ------------------------------------ Fin subir QR -------------------------------------------

  const fetchPost = async () => {
    try {
      const proveedores = await getSelectTypeProvider();
      const stock = await getSelectTypeStock();
      if (proveedores) setSelectProvider(proveedores);
      if (stock) setSelectStock(stock);
    } catch (err) {
      console.error(err);
    }
  };

  const onClose = () => {
    handleClose(true);
    productForm.resetForm();
    setTextStepper('Continuar');
    setLoading(false);
    setCurrentSchema(ValidationSchema[0]);
    setSelectedOptionSupplier(null);
    setSelectedOptionStock(null);
    setDataInventario([]);
    setPreviewImage('');
    setFileName('');
    setFileSize(0);
    setSelectTypeStock(0);
  };

  const onPurchasePriceChange = (values: { floatValue: any | null }): void => {
    const { floatValue } = values;
    const newBalance = floatValue ?? 0;

    productForm.setFieldValue('purchasePrice', newBalance);
  };

  const onSalePriceChange = (values: { floatValue: any | null }): void => {
    const { floatValue } = values;
    const newBalance = floatValue ?? 0;

    productForm.setFieldValue('salePrice', newBalance);
  };

  const handleTypeSupplier = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedOptionSupplier(selectedOption);
    productForm.setFieldValue('typeSupplier', id);
  };

  const handleTypeStock = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedOptionStock(selectedOption);
    setSelectTypeStock(id);
    if (id === 1) {
      setQrData([]);
    }
    productForm.setFieldValue('typeStock', id);
  };

  const EstatusResponse = (res: string) => {
    switch (res) {
      case 'Válido':
        return <span className="fs-7 fw-semibold text-success">Válido</span>;
      case 'ICCID duplicado':
        return (
          <span className="fs-7 fw-semibold text-danger">ICCID duplicado</span>
        );
      case 'ICCID inválido':
        return (
          <span className="fs-7 fw-semibold text-warning">ICCID inválido</span>
        );
    }
  };
  const EstatusResponseQR = (res: string) => {
    switch (res) {
      case 'Asignado':
        return <span className="fs-7 fw-semibold text-primary">Asignado</span>;
      case 'No asignada':
        return (
          <span className="fs-7 fw-semibold text-warning">No asignada</span>
        );
    }
  };

  useEffect(() => {
    if (selectTypeStock === 2) {
      productForm.setFieldValue('location', 'N/A');
    }
  }, [selectTypeStock]);

  useEffect(() => {
    fetchPost();
  }, [show]);
  return (
    <>
      <Modal
        id="kt_modal_create"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog modal-dialog-centered modal-xl"
        show={show}
        onHide={onClose}
        backdrop="static"
      >
        <div className="modal-content">
          <div className="modal-header pb-0 border-0 justify-content-end">
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>

          <div className="modal-body scroll-y mx-5 pt-0">
            <div className="text-center mb-13">
              <h1 className="mb-3">Agregar producto</h1>
            </div>
            <form
              id="kt_modal_generic_form"
              className="form"
              action="#"
              onSubmit={productForm.handleSubmit}
            >
              <Stepper
                headers={stepperHeaders}
                loading={loading}
                onCancel={onClose}
                stepper={stepper}
                textButton={textStepper}
                onBack={(actionBack: any) => {
                  if (actionBack == 1) {
                    setCurrentSchema(null);
                  }
                  if (actionBack == 0) {
                    setCurrentSchema(ValidationSchema[0]);
                  }
                }}
              >
                {/* ------------------------------- Alta de producto ----------------------------------- */}
                <div className="w-100 container">
                  <span className="fw-bolder fs-5">Detalles generales</span>
                  <div className="separator border-2 my-10" />
                  <div className="row" style={{ marginBottom: '60px' }}>
                    <div className="col-3">
                      <div className="col-lg-8">
                        <div
                          className="image-input image-input-outline"
                          data-kt-image-input="true"
                        >
                          <img
                            src={
                              previewImage
                                ? previewImage
                                : toAbsoluteUrl('/media/avatars/Vector.png')
                            }
                            className="image-input-wrapper w-200px h-200px bg-secondary"
                            crossOrigin="anonymous"
                            alt="paquete"
                          />
                          <label
                            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                            data-kt-image-input-action="change"
                            data-bs-toggle="tooltip"
                            title="Change avatar"
                          >
                            <i className="bi bi-pencil-fill fs-7"></i>
                            <input
                              type="file"
                              name="avatar"
                              accept=".png, .jpg, .jpeg"
                              onChange={(event) => {
                                if (event.currentTarget.files) {
                                  let file = event.currentTarget.files[0];
                                  const MAX_FILE_SIZE_MB = 5;
                                  const MAX_FILE_SIZE_BYTES =
                                    MAX_FILE_SIZE_MB * 1024 * 1024;
                                  if (file.size > MAX_FILE_SIZE_BYTES) {
                                    SimpleAlert(
                                      'El peso de la imagen del producto debe ser de un máximo de 5MB',
                                      3000,
                                      'error'
                                    );
                                    return;
                                  }
                                  let reader = new FileReader();
                                  reader.onload = () => {
                                    const csv: string = reader.result as string;
                                    setPreviewImage(csv);
                                  };
                                  reader.readAsDataURL(file);
                                  productForm.setFieldValue('avatar', file);
                                }
                              }}
                            />
                          </label>
                          <span
                            className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                            data-kt-image-input-action="cancel"
                            data-bs-toggle="tooltip"
                            title="Cancel avatar"
                          >
                            <i className="bi bi-x fs-2"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-9">
                      <div className="row">
                        <div className="col mb-7">
                          <div className="w-100 d-flex">
                            <label className="fw-bold fs-6 mb-2 required">
                              Tipo
                            </label>
                          </div>
                          <div onClick={(e) => e.stopPropagation()}>
                            <Select
                              options={selectStock}
                              placeholder={'Seleccione'}
                              onChange={handleTypeStock}
                              value={selectedOptionStock}
                              noOptionsMessage={() => {
                                return <span>No hay registros</span>;
                              }}
                              styles={{
                                indicatorSeparator: (provided, state) => ({
                                  ...provided,
                                  display: 'none',
                                }),

                                control: (provided, state) => ({
                                  ...provided,
                                  border: '1px solid #e4e6ef',
                                  borderRadius: '6px',
                                  padding: '3px',
                                  fontSize: '1.1rem',
                                  boxShadow: 'none',
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  fontSize: '1.1rem',
                                }),
                              }}
                            />
                            {productForm.touched.typeStock &&
                              productForm.errors.typeStock && (
                                <div className="fv-plugins-message-container text-danger  ms-5">
                                  <span role="alert">
                                    {productForm.errors.typeStock}
                                  </span>
                                </div>
                              )}
                          </div>
                        </div>
                        <div className="col mb-7">
                          <div className="w-100 d-flex">
                            <label className="fw-bold fs-6 mb-2 required">
                              Proveedor
                            </label>
                          </div>
                          <div onClick={(e) => e.stopPropagation()}>
                            <Select
                              options={selectProvider}
                              placeholder={'Seleccione'}
                              onChange={handleTypeSupplier}
                              value={selectedOptionSupplier}
                              noOptionsMessage={() => {
                                return <span>No hay registros</span>;
                              }}
                              styles={{
                                indicatorSeparator: (provided, state) => ({
                                  ...provided,
                                  display: 'none',
                                }),

                                control: (provided, state) => ({
                                  ...provided,
                                  border: '1px solid #e4e6ef',
                                  borderRadius: '6px',
                                  padding: '3px',
                                  fontSize: '1.1rem',
                                  boxShadow: 'none',
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  fontSize: '1.1rem',
                                }),
                              }}
                            />
                            {productForm.touched.typeSupplier &&
                              productForm.errors.typeSupplier && (
                                <div className="fv-plugins-message-container text-danger  ms-5">
                                  <span role="alert">
                                    {productForm.errors.typeSupplier}
                                  </span>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="w-100 d-flex">
                        <label className="fw-bold fs-6 mb-2 required">
                          Descripción
                        </label>
                      </div>
                      <textarea
                        placeholder="Descripción"
                        className="form-control mb-3 mb-lg-0"
                        value={productForm.values.description}
                        onChange={(e) =>
                          productForm.setFieldValue(
                            'description',
                            e.target.value
                          )
                        }
                      />
                      {productForm.touched.description &&
                        productForm.errors.description && (
                          <div className="fv-plugins-message-container text-danger  ms-5">
                            <span role="alert">
                              {productForm.errors.description}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                  <span className="fw-bolder fs-5">Precios</span>
                  <div className="separator border-2 my-10" />

                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col mb-7">
                          <div className="w-100 d-flex">
                            <label className="fw-bold fs-6 mb-2 required">
                              Precio de compra
                            </label>
                          </div>
                          <NumericFormat
                            name="purchasePrice"
                            type="text"
                            autoComplete="off"
                            className="form-control mb-3 w-100"
                            value={productForm.values.purchasePrice}
                            decimalScale={2}
                            decimalSeparator="."
                            fixedDecimalScale
                            placeholder="$ 0.00"
                            prefix="$ "
                            allowNegative={false}
                            thousandSeparator=","
                            onValueChange={(values) =>
                              onPurchasePriceChange(values)
                            }
                          />
                          {productForm.touched.purchasePrice &&
                            productForm.errors.purchasePrice && (
                              <div className="fv-plugins-message-container text-danger  ms-5">
                                <span role="alert">
                                  {productForm.errors.purchasePrice}
                                </span>
                              </div>
                            )}
                        </div>
                        <div className="col mb-7">
                          <div className="w-100 d-flex">
                            <label className="fw-bold fs-6 mb-2 required">
                              Precio de venta
                            </label>
                          </div>

                          <NumericFormat
                            name="salePrice"
                            type="text"
                            autoComplete="off"
                            className="form-control mb-3 w-100"
                            value={productForm.values.salePrice}
                            decimalScale={2}
                            decimalSeparator="."
                            fixedDecimalScale
                            placeholder="$ 0.00"
                            prefix="$ "
                            allowNegative={false}
                            thousandSeparator=","
                            onValueChange={(values) =>
                              onSalePriceChange(values)
                            }
                          />
                          {productForm.touched.salePrice &&
                            productForm.errors.salePrice && (
                              <div className="fv-plugins-message-container text-danger  ms-5">
                                <span role="alert">
                                  {productForm.errors.salePrice}
                                </span>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ------------------------------- Fin alta de producto ----------------------------------- */}
                {/* ------------------------------- Almacenaje ----------------------------------- */}
                <div className="w-100 container">
                  <span className="fw-bolder fs-5">Almacenamiento</span>
                  <div className="separator border-2 my-10" />
                  <div className="row">
                    <div className="col-6">
                      <div className="w-100 d-flex">
                        <label className="fw-bold fs-6 mb-2 required">
                          Ubicación
                        </label>
                      </div>
                      <input
                        type="text"
                        placeholder="Ej. 543356-001"
                        className="form-control mb-3 mb-lg-0 w-75"
                        disabled={selectTypeStock === 2 ? true : false}
                        value={productForm.values.location}
                        onChange={(e) =>
                          productForm.setFieldValue('location', e.target.value)
                        }
                      />
                      {productForm.touched.location &&
                        productForm.errors.location && (
                          <div className="fv-plugins-message-container text-danger  ms-5">
                            <span role="alert">
                              {productForm.errors.location}
                            </span>
                          </div>
                        )}
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col mb-7">
                          <div className="w-100 d-flex">
                            <label className="fw-bold fs-6 mb-2 required">
                              Cantidad
                            </label>
                          </div>
                          <NumericFormat
                            name="cantidad"
                            type="text"
                            autoComplete="off"
                            className="form-control mb-3 w-100"
                            value={dataInventario.length}
                            decimalScale={0}
                            allowNegative={false}
                            disabled
                            suffix=" PZS"
                            thousandSeparator=","
                          />
                        </div>
                        <div className="col mb-7">
                          <div className="w-100 d-flex">
                            <label className="fw-bold fs-6 mb-2 required">
                              Valor
                            </label>
                          </div>

                          <NumericFormat
                            name="sell"
                            type="text"
                            autoComplete="off"
                            className="form-control mb-3 w-100"
                            value={
                              dataInventario
                                ? dataInventario.length *
                                  productForm.values.salePrice
                                : 0
                            }
                            decimalScale={2}
                            decimalSeparator="."
                            fixedDecimalScale
                            placeholder="$ 0.00"
                            prefix="$ "
                            disabled
                            allowNegative={false}
                            thousandSeparator=","
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row align-items-stretch"
                    style={{ minHeight: '220px' }}
                  >
                    <div
                      className={`${
                        selectTypeStock === 2 ? 'col-6' : 'col-12'
                      } h-100`}
                    >
                      {selectTypeStock === 2 ? (
                        <div className="text-center fw-bold mb-5">
                          Paso 1. Carga de registros
                        </div>
                      ) : null}
                      <div
                        className="border border-dashed border-gray-500 d-flex justify-content-center text-center flex-column p-8 h-250px overflow-hidden"
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onClick={handleClick}
                      >
                        <input
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={handleFileChange}
                          ref={inputRef}
                          style={{ display: 'none' }}
                        />
                        <a className="text-gray-800 text-hover-primary d-flex flex-column">
                          <div className="symbol symbol-75px mb-6">
                            <img
                              src={toAbsoluteUrl('/media/svg/files/xls.svg')}
                              alt=""
                            />
                          </div>
                          <div className="fs-5 fw-bolder mb-2">
                            {dataInventario.length
                              ? `Archivo seleccionado: ${fileName}`
                              : 'Arrastre y suelte sus archivos aquí o seleccione un archivo'}
                          </div>
                        </a>
                        <div className="fs-7 fw-bold text-gray-500 mt-auto">
                          {dataInventario.length
                            ? `Peso del archivo: ${(
                                fileSize /
                                (1024 * 1024)
                              ).toFixed(2)} MB`
                            : 'Tamaño máximo de archivo: 15 MB'}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        selectTypeStock === 2 ? 'col-6' : 'd-none'
                      } h-100
                      ${
                        !dataInventario.length
                          ? 'opacity-50 pointer-events-none'
                          : ''
                      }
                      `}
                    >
                      {selectTypeStock === 2 ? (
                        <div className="text-center fw-bold mb-5">
                          Paso 2. Carga de QR
                        </div>
                      ) : null}
                      <div className="h-100 d-flex flex-column overflow-hidden">
                        <QRImageUploader
                          onDataChange={handleDataChange}
                          disabled={!dataInventario.length}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-9">
                    <button
                      className="btn btn-danger d-inline-flex align-items-center"
                      disabled={selectedRows.size === 0}
                      onClick={handleDeleteSelected}
                    >
                      Eliminar
                      <KTSVG
                        path="/media/icons/duotune/general/gen027.svg"
                        className="svg-icon-3 svg-icon-gray-500 ms-2 align-middle"
                      />
                    </button>
                  </div>

                  <div className="mt-5 py-3">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: '500px', overflowY: 'auto' }}
                    >
                      <table className="table align-middle gs-0 gy-4">
                        <thead
                          style={{
                            position: 'sticky',
                            top: 0,
                            background: '#f9f9f9',
                            zIndex: 2,
                          }}
                        >
                          <tr className="fw-bold text-muted bg-light">
                            <th className="min-w-50px">
                              <input
                                className="form-check-input ms-3"
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={toggleSelectAll}
                              />
                            </th>

                            <th className="ps-4 min-w-200px rounded-start">
                              IMSI
                            </th>
                            <th className="min-w-125px">ICCID</th>
                            <th className="min-w-125px">PUK</th>
                            <th className="min-w-125px">PIN</th>
                            <th className="min-w-125px">Respuesta</th>
                            {selectTypeStock === 2 ? (
                              <th className="min-w-125px">QR</th>
                            ) : null}
                          </tr>
                        </thead>
                        <tbody>
                          {dataInventario?.map((item: any, index: any) => (
                            <tr key={index}>
                              <td>
                                <input
                                  className="form-check-input ms-3"
                                  type="checkbox"
                                  checked={selectedRows.has(index)}
                                  onChange={() => toggleSelect(index)}
                                />
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="d-flex justify-content-start flex-column">
                                    <span className="text-gray-900 fw-bold text-hover-primary mb-1 fs-6">
                                      {item.imsi}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                                  {item.iccid}
                                </span>
                              </td>
                              <td>
                                <a className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                                  {item.puk}
                                </a>
                              </td>
                              <td>
                                <span className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                                  {item.pin}
                                </span>
                              </td>
                              <td>
                                {item.respuesta
                                  ? EstatusResponse(item.respuesta)
                                  : ''}
                              </td>
                              {selectTypeStock === 2 ? (
                                <td>
                                  <span className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                                    {item.resQR
                                      ? EstatusResponseQR(item.resQR)
                                      : ''}
                                  </span>
                                </td>
                              ) : null}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* ------------------------------- Fin almacenaje ----------------------------------- */}

                <div className="d-flex flex-column justify-content-center align-items-center w-100">
                  <h1 className="text-primary fw-bolder text-center">
                    El producto se ha agregado correctamente al inventario
                  </h1>
                  <div className="w-350px rounded mx-auto d-block">
                    <AnimationSucces />
                  </div>
                </div>
              </Stepper>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};
export { CreateModal };
